const toggleButtons = document.querySelectorAll('.js-navigationToggle');
const navigation = document.querySelector('.js-navigation');
const navigationRight = document.querySelector('.js-navigationRight');
const hamburger = document.querySelector('.js-hamburger');
const body = document.querySelector('body');
const menuItemsWithChildren = document.querySelectorAll('.js-navigation .menu-item-has-children');

toggleButtons.forEach(button => {
    button.addEventListener('click', function () {
        const isOpen = navigation.classList.toggle('-open');
        const isOpenRight = navigationRight.classList.toggle('-open');
        const isOpenHamburger = hamburger.classList.toggle('-active');
        body.classList.toggle('-menuOpen', isOpen);
        if (isOpen) {
            requestAnimationFrame(() => navigation.focus());
        }
    });
});

menuItemsWithChildren.forEach(menuItem => {
    menuItem.addEventListener('click', function (e) {
        if (!e.target.parentElement.classList.contains('menu-item-has-children')) {
            return;
        }
        if (window.innerWidth <= 1149) e.preventDefault();
        const isOpen = menuItem.classList.toggle('-open');
        const subMenu = menuItem.querySelector('.sub-menu');
        if (subMenu) {
            subMenu.classList.toggle('-open', isOpen);
        }
    });
});